import React from "react";
import "./Contact.css";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";

const ContactUs = () => {
  return (
    <div className="contact-page" id="contact">
      <div className="contact-container">
        <h1 className="contact-title">Contact Our Experts</h1>
        <p className="contact-subtitle">
          We're here to help you find your dream property. Fill out the form
          below or visit us at our office.
        </p>

        <div className="contact-content">
          {/* Left Section */}
          <div className="contact-info">
            <div className="info-box">
              <FaMapMarkerAlt className="icon" />
              <div>
                <h4>Our Office</h4>
                <p>123 Luxury Avenue, Suite 100, Metropolis, 54321</p>
                <a href="#" className="link">
                  Get directions
                </a>
              </div>
            </div>

            <div className="info-box">
              <FaPhoneAlt className="icon" />
              <div>
                <h4>Phone Number</h4>
                <p>+1 (234) 567-8900</p>
                <a href="tel:+12345678900" className="link">
                  Call us
                </a>
              </div>
            </div>

            <div className="info-box">
              <FaEnvelope className="icon" />
              <div>
                <h4>Email Address</h4>
                <p>contact@dhanushdhari.com</p>
                <a href="mailto:contact@dhanushdhari.com" className="link">
                  Email us
                </a>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <form className="contact-form">
            <input type="text" placeholder="Full Name" required />
            <input type="email" placeholder="Email Address" required />
            <textarea placeholder="Tell us how we can help..." required></textarea>
            <button type="submit">Send a Query Mail</button>
          </form>
        </div>
      </div>

      {/* <footer className="contact-footer">
        <p>© 2024 Dhanushdhari Real Estate LLP. All rights reserved.</p>
        <div>
          <a href="#">Privacy Policy</a> | <a href="#">Terms of Service</a>
        </div>
      </footer> */}
    </div>
  );
};

export default ContactUs;
